/* Snow Dawg Co. theme — vanilla JS, no dependencies */
(function () {
  'use strict';

  var SDC = (window.SDC = window.SDC || {});
  var routes = SDC.routes || { cartAdd: '/cart/add.js', cartChange: '/cart/change.js', cart: '/cart.js', cartPage: '/cart' };
  var STR = SDC.strings || {};
  function t(key, fallback) { return STR[key] || fallback; }

  /* ---------- Money ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = Number(cents) || 0;
    format = format || SDC.moneyFormat || '${{amount}}';
    function fmt(number, precision, thousands, decimal) {
      thousands = thousands === undefined ? ',' : thousands;
      decimal = decimal === undefined ? '.' : decimal;
      var n = (number / 100).toFixed(precision);
      var parts = n.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return parts[1] ? dollars + decimal + parts[1] : dollars;
    }
    var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var value = '';
    switch (match ? match[1] : 'amount') {
      case 'amount_no_decimals': value = fmt(cents, 0); break;
      case 'amount_with_comma_separator': value = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = fmt(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = fmt(cents, 2, "'", '.'); break;
      case 'amount_with_space_separator': value = fmt(cents, 2, ' ', ','); break;
      default: value = fmt(cents, 2);
    }
    return match ? format.replace(match[0], value) : value;
  }
  SDC.formatMoney = formatMoney;

  /* ---------- Cart API (overridable for the preview via window.SDC.cartApi) ---------- */
  function fetchJSON(url, opts) {
    var options = Object.assign({ credentials: 'same-origin', headers: { Accept: 'application/json' } }, opts || {});
    return fetch(url, options).then(function (res) {
      return res.text().then(function (text) {
        var data = null;
        try { data = text ? JSON.parse(text) : null; } catch (e) { data = null; }
        if (!res.ok) {
          var err = new Error((data && (data.description || data.message)) || 'HTTP ' + res.status);
          err.status = res.status;
          err.data = data;
          throw err;
        }
        return data;
      });
    });
  }
  var jsonHeaders = { 'Content-Type': 'application/json', Accept: 'application/json' };
  var cartApi = SDC.cartApi || {
    get: function () { return fetchJSON(routes.cart); },
    add: function (items) { return fetchJSON(routes.cartAdd, { method: 'POST', headers: jsonHeaders, body: JSON.stringify({ items: items }) }); },
    // Posts the whole product form, so anything a bundle app adds to it goes along.
    addForm: function (form) { return fetchJSON(routes.cartAdd, { method: 'POST', body: new FormData(form) }); },
    change: function (key, quantity) { return fetchJSON(routes.cartChange, { method: 'POST', headers: jsonHeaders, body: JSON.stringify({ id: key, quantity: quantity }) }); }
  };
  SDC.cartApi = cartApi;

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function el(tag, cls, text) { var n = document.createElement(tag); if (cls) n.className = cls; if (text !== undefined) n.textContent = text; return n; }
  function sizedImage(url, width) {
    if (!url) return '';
    if (/^(data:|blob:)/.test(url)) return url;
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + width;
  }

  /* ---------- Announcement bar ---------- */
  function initAnnouncement(root) {
    var msgs = $$('[data-announcement-msg]', root);
    if (msgs.length < 2 || root.__sdc) return;
    root.__sdc = true;
    var i = 0, paused = false;
    var interval = (Number(root.dataset.interval) || 4) * 1000;
    root.addEventListener('mouseenter', function () { paused = true; });
    root.addEventListener('mouseleave', function () { paused = false; });
    root.addEventListener('focusin', function () { paused = true; });
    root.addEventListener('focusout', function () { paused = false; });
    setInterval(function () {
      if (paused || document.hidden) return;
      msgs[i].classList.remove('is-active');
      i = (i + 1) % msgs.length;
      msgs[i].classList.add('is-active');
    }, interval);
  }

  /* ---------- Mobile nav ---------- */
  function initNav() {
    var toggle = $('[data-nav-toggle]');
    var nav = $('[data-nav]');
    if (!toggle || !nav || toggle.__sdc) return;
    toggle.__sdc = true;
    function set(open) {
      nav.classList.toggle('is-open', open);
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
    toggle.addEventListener('click', function () { set(!nav.classList.contains('is-open')); });
    $$('[data-nav-link]', nav).forEach(function (a) { a.addEventListener('click', function () { set(false); }); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && nav.classList.contains('is-open')) { set(false); toggle.focus(); } });
  }

  /* ---------- Product gallery ---------- */
  function initGallery(root) {
    if (root.__sdc) return;
    root.__sdc = true;
    var track = $('[data-gallery-track]', root);
    var slides = $$('[data-gallery-slide]', root);
    var thumbs = $$('[data-gallery-thumb]', root);
    var thumbsWrap = $('[data-gallery-thumbs]', root);
    var prev = $('[data-gallery-prev]', root);
    var next = $('[data-gallery-next]', root);
    var counter = $('[data-gallery-counter]', root);
    if (!track || slides.length === 0) return;
    var index = 0;

    function update() {
      if (counter) counter.textContent = (index + 1) + ' / ' + slides.length;
      thumbs.forEach(function (th, i) {
        var active = i === index;
        th.classList.toggle('is-active', active);
        if (active) {
          th.setAttribute('aria-current', 'true');
          if (thumbsWrap) {
            var left = th.offsetLeft - thumbsWrap.clientWidth / 2 + th.clientWidth / 2;
            thumbsWrap.scrollTo({ left: Math.max(0, left), behavior: 'smooth' });
          }
        } else {
          th.removeAttribute('aria-current');
        }
      });
      if (prev) prev.disabled = index === 0;
      if (next) next.disabled = index === slides.length - 1;
    }
    function goTo(i) {
      index = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: slides[index].offsetLeft, behavior: 'smooth' });
      update();
    }
    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        var w = track.clientWidth || 1;
        var i = Math.round(track.scrollLeft / w);
        if (i !== index) { index = Math.max(0, Math.min(slides.length - 1, i)); update(); }
      });
    }, { passive: true });
    if (prev) prev.addEventListener('click', function () { goTo(index - 1); });
    if (next) next.addEventListener('click', function () { goTo(index + 1); });
    thumbs.forEach(function (th) { th.addEventListener('click', function () { goTo(Number(th.dataset.galleryThumb)); }); });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); goTo(index + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(index - 1); }
    });
    window.addEventListener('resize', function () { track.scrollTo({ left: slides[index].offsetLeft }); });
    update();
    root.__goTo = goTo;
  }

  /* ---------- Bundle selector ---------- */
  var bundleConfig = null; // { productId, pct2, pct3 } for the cart mismatch check

  function initBundle(root) {
    if (root.__sdc) return;
    root.__sdc = true;
    var section = root.closest('[data-section-id]') || document;
    var jsonEl = $('[data-product-json]', section);
    if (!jsonEl) return;
    var product;
    try { product = JSON.parse(jsonEl.textContent); } catch (e) { return; }
    var pct = { 1: 0, 2: Number(root.dataset.pct2) || 0, 3: Number(root.dataset.pct3) || 0 };
    bundleConfig = { productId: Number(root.dataset.productId) || product.id, pct2: pct[2], pct3: pct[3] };
    var variantsById = {};
    function toCents(x) {
      if (typeof x === 'string') x = x.indexOf('.') > -1 ? Math.round(parseFloat(x) * 100) : Number(x);
      return Number(x) || 0;
    }
    (product.variants || []).forEach(function (v) {
      v.price = toCents(v.price);
      v.compare_at_price = toCents(v.compare_at_price);
      variantsById[String(v.id)] = v;
    });
    // Each size button also carries its own price, used whenever the product data is missing or unreadable.
    function variantFromInput(inp) {
      if (!inp) return null;
      var known = variantsById[String(inp.value)];
      if (known && known.price > 0) return known;
      if (!inp.dataset.price) return known || null;
      return {
        id: Number(inp.dataset.variantId || inp.value),
        title: inp.dataset.title || '',
        price: toCents(inp.dataset.price),
        compare_at_price: toCents(inp.dataset.compare),
        available: inp.dataset.available !== 'false' && !inp.disabled,
        featured_image: known ? known.featured_image : null
      };
    }
    var firstAvailable = (product.variants || []).filter(function (v) { return v.available; })[0] || (product.variants || [])[0];

    var form = $('[data-bundle-form]', root);
    var optionLabels = $$('[data-bundle-option]', root);
    var qtyInputs = $$('[data-bundle-qty]', root);
    var rows = $$('[data-bundle-item]', root);
    var totalEl = $('[data-bundle-total]', root);
    var saveWrap = $('[data-bundle-save]', root);
    var saveEl = $('[data-bundle-save-amount]', root);
    var addBtn = $('[data-bundle-add]', root);
    var addLabel = $('[data-bundle-add-label]', root);
    var errorEl = $('[data-bundle-error]', root);
    var sticky = $('[data-sticky-atc]', section);
    var stickyLabel = sticky && $('[data-sticky-label]', sticky);
    var stickyTotal = sticky && $('[data-sticky-total]', sticky);
    var stickyBtn = sticky && $('[data-sticky-add]', sticky);
    var defaultImage = product.featured_image || '';
    var busy = false;

    // Make sure no sold-out size starts selected.
    rows.forEach(function (row) {
      var checked = $('input[type=radio]:checked', row);
      if (!checked || checked.disabled) {
        var first = $('input[type=radio]:not([disabled])', row);
        if (first) first.checked = true;
      }
    });

    function currentQty() {
      var c = qtyInputs.filter(function (i) { return i.checked; })[0];
      return c ? Number(c.value) : 1;
    }
    function rowVariant(i) {
      var row = rows[i];
      if (!row) return firstAvailable;
      var c = $('input[type=radio]:checked', row);
      return variantFromInput(c);
    }
    function selectedVariants(n) {
      var list = [];
      if (rows.length === 0) {
        var fallbackInput = $('input[name="id"]', form);
        var v = variantFromInput(fallbackInput) || firstAvailable;
        for (var k = 0; k < n; k++) list.push(v);
        return list;
      }
      for (var j = 0; j < n; j++) list.push(rowVariant(j));
      return list;
    }
    function priceFor(n) {
      var vs = selectedVariants(n);
      var full = 0, compare = 0, ok = true;
      vs.forEach(function (v) {
        if (!v) { ok = false; return; }
        full += v.price;
        compare += Math.max(v.compare_at_price || 0, v.price);
        if (!v.available) ok = false;
      });
      var total = Math.round(full * (100 - pct[n]) / 100);
      return { full: full, total: total, compare: compare, save: full - total, ok: ok, variants: vs };
    }

    function update() {
      var n = currentQty();
      optionLabels.forEach(function (label) {
        var input = $('[data-bundle-qty]', label);
        var on = input && input.checked;
        label.classList.toggle('is-selected', !!on);
        var q = Number(input.value);
        var p = priceFor(q);
        var tot = $('[data-bundle-opt-total]', label);
        var each = $('[data-bundle-opt-each]', label);
        var cmp = $('[data-bundle-opt-compare]', label);
        if (!(p.full > 0)) return; // never replace the server-rendered price with $0.00
        if (tot) tot.textContent = formatMoney(p.total);
        if (each) each.textContent = formatMoney(Math.round(p.total / q));
        if (cmp) cmp.textContent = formatMoney(Math.max(p.compare, p.full));
      });
      rows.forEach(function (row, i) {
        row.hidden = i >= n;
        $$('.pill', row).forEach(function (pill) {
          var inp = $('input', pill);
          pill.classList.toggle('is-checked', !!(inp && inp.checked));
        });
        var v = rowVariant(i);
        var img = $('.bundle-item__img', row);
        if (img && v) {
          var src = (v.featured_image && v.featured_image.src) || defaultImage;
          if (src) {
            var want = sizedImage(src, 160);
            if (img.getAttribute('data-current') !== want) {
              img.setAttribute('data-current', want);
              img.removeAttribute('srcset');
              img.src = want;
            }
          }
        }
      });
      var p = priceFor(n);
      if (!(p.full > 0)) { console.warn('[Snow Dawg] Could not read variant prices; keeping the prices rendered by Shopify.'); return; }
      if (totalEl) totalEl.textContent = formatMoney(p.total);
      if (saveWrap) {
        saveWrap.hidden = p.save <= 0;
        if (saveEl) saveEl.textContent = formatMoney(p.save);
      }
      var label = p.ok ? t('addToCart', 'Add to cart') + ' · ' + formatMoney(p.total) : t('soldOut', 'Sold out');
      if (addBtn && !busy) { addBtn.disabled = !p.ok; if (addLabel) addLabel.textContent = label; }
      if (stickyLabel) stickyLabel.textContent = (optionLabels[n - 1] ? $('.bundle-opt__title', optionLabels[n - 1]).textContent.split('·')[0].trim() : 'Buy ' + n);
      if (stickyTotal) stickyTotal.textContent = formatMoney(p.total);
      if (stickyBtn && !busy) { stickyBtn.disabled = !p.ok; stickyBtn.textContent = p.ok ? t('addToCart', 'Add to cart') : t('soldOut', 'Sold out'); }
      if (errorEl && !busy) errorEl.hidden = true;
    }

    function setBusy(state) {
      busy = state;
      [addBtn, stickyBtn].forEach(function (b) {
        if (!b) return;
        b.classList.toggle('is-loading', state);
        b.disabled = state;
      });
      if (state) {
        if (addLabel) addLabel.textContent = t('adding', 'Adding…');
        if (stickyBtn) stickyBtn.textContent = t('adding', 'Adding…');
      }
    }
    function showError(msg) {
      if (!errorEl) return;
      errorEl.textContent = msg;
      errorEl.hidden = false;
    }

    function submit() {
      if (busy) return;
      var n = currentQty();
      var p = priceFor(n);
      if (!p.ok) { showError(t('soldOut', 'Sold out')); return; }
      var merged = {};
      var order = [];
      p.variants.forEach(function (v) {
        var key = String(v.id);
        if (!merged[key]) { merged[key] = 0; order.push(key); }
        merged[key] += 1;
      });
      var items = order.map(function (id) { return { id: Number(id), quantity: merged[id] }; });
      setBusy(true);
      cartApi.add(items)
        .then(function () { return Cart.refresh(); })
        .then(function () { setBusy(false); update(); Cart.open(); })
        .catch(function (err) {
          setBusy(false);
          update();
          showError((err && err.message && err.status) ? err.message : t('addError', 'Sorry, we couldn\'t add that to your cart.'));
        });
    }

    root.addEventListener('change', function (e) {
      if (e.target.matches('[data-bundle-qty], .bundle-item input[type=radio]')) update();
    });
    if (form) form.addEventListener('submit', function (e) { e.preventDefault(); submit(); });
    if (stickyBtn) stickyBtn.addEventListener('click', submit);

    // Sticky bar: show once the main add button has scrolled above the viewport.
    if (sticky && addBtn && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          sticky.classList.toggle('is-visible', show);
          sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
          if (stickyBtn) stickyBtn.tabIndex = show ? 0 : -1;
        });
      });
      io.observe(addBtn);
    }
    update();
    root.__update = update;
  }

  /* ---------- Buy buttons (standard product form, for bundle apps like Kaching) ---------- */
  function initBuyButtons(root) {
    if (root.__sdc) return;
    root.__sdc = true;
    var section = root.closest('[data-section-id]') || document;
    var form = $('form', root);
    var idInput = $('[data-buy-id]', root);
    var sizes = $$('[data-buy-size]', root);
    var addBtn = $('[data-buy-add]', root);
    var addLabel = $('[data-buy-add-label]', root);
    var errorEl = $('[data-buy-error]', root);
    var priceCurrent = $('[data-price-current]', section);
    var priceCompare = $('[data-price-compare]', section);
    var sticky = $('[data-bundle]', section) ? null : $('[data-sticky-atc]', section);
    var stickyLabel = sticky && $('[data-sticky-label]', sticky);
    var stickyTotal = sticky && $('[data-sticky-total]', sticky);
    var stickyBtn = sticky && $('[data-sticky-add]', sticky);
    var busy = false;

    function selected() {
      return sizes.filter(function (s) { return s.checked; })[0] || null;
    }
    function update() {
      var s = selected();
      if (!s && sizes.length) {
        s = sizes.filter(function (x) { return !x.disabled; })[0] || null;
        if (s) s.checked = true;
      }
      sizes.forEach(function (x) { x.closest('.pill').classList.toggle('is-checked', x === s); });
      var available = s ? s.dataset.available !== 'false' && !s.disabled : !addBtn || !addBtn.disabled;
      if (s && idInput && idInput.value !== s.value) {
        idInput.value = s.value;
        // Bundle apps listen for this to follow the chosen size.
        idInput.dispatchEvent(new Event('change', { bubbles: true }));
        if (window.history && history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', s.value);
          history.replaceState(history.state, '', url.toString());
        }
      }
      if (s) {
        var price = Number(s.dataset.price) || 0;
        var compare = Number(s.dataset.compare) || 0;
        if (price > 0 && priceCurrent) priceCurrent.textContent = formatMoney(price);
        if (price > 0 && priceCompare && compare > price) priceCompare.textContent = formatMoney(compare);
        if (stickyTotal && price > 0) stickyTotal.textContent = formatMoney(price);
        if (stickyLabel) stickyLabel.textContent = s.dataset.title || '';
      }
      if (addBtn && !busy) {
        addBtn.disabled = !available;
        if (addLabel) addLabel.textContent = available ? t('addToCart', 'Add to cart') : t('soldOut', 'Sold out');
      }
      if (stickyBtn && !busy) { stickyBtn.disabled = !available; stickyBtn.textContent = available ? t('addToCart', 'Add to cart') : t('soldOut', 'Sold out'); }
      if (errorEl && !busy) errorEl.hidden = true;
    }
    function setBusy(state) {
      busy = state;
      [addBtn, stickyBtn].forEach(function (b) {
        if (!b) return;
        b.classList.toggle('is-loading', state);
        b.disabled = state;
      });
      if (state && addLabel) addLabel.textContent = t('adding', 'Adding…');
    }

    root.addEventListener('change', function (e) {
      if (e.target.matches('[data-buy-size]')) update();
    });

    // If a bundle app handles the click itself it cancels the event and this never runs.
    if (form && root.dataset.ajax === 'true') {
      form.addEventListener('submit', function (e) {
        if (e.defaultPrevented || busy) return;
        e.preventDefault();
        setBusy(true);
        var request = cartApi.addForm
          ? cartApi.addForm(form)
          : cartApi.add([{ id: Number(idInput.value), quantity: Number(($('[name="quantity"]', form) || {}).value) || 1 }]);
        request
          .then(function () { return Cart.refresh(); })
          .then(function () { setBusy(false); update(); Cart.open(); })
          .catch(function (err) {
            setBusy(false);
            update();
            if (errorEl) {
              errorEl.textContent = (err && err.message && err.status) ? err.message : t('addError', 'Sorry, we couldn\'t add that to your cart.');
              errorEl.hidden = false;
            }
          });
      });
    }

    // Sticky bar presses the real button, so a bundle app sees the same click.
    if (stickyBtn && addBtn) stickyBtn.addEventListener('click', function () { addBtn.click(); });
    if (sticky && addBtn && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          sticky.classList.toggle('is-visible', show);
          sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
          if (stickyBtn) stickyBtn.tabIndex = show ? 0 : -1;
        });
      });
      io.observe(addBtn);
    }
    update();
  }

  /* ---------- Cart drawer ---------- */
  var Cart = {
    drawer: null, panel: null, lastFocus: null, state: null,

    init: function () {
      this.drawer = $('[data-cart-drawer]');
      if (!this.drawer || this.drawer.__sdc) return;
      this.drawer.__sdc = true;
      this.panel = $('[data-drawer-panel]', this.drawer);
      var self = this;
      $$('[data-drawer-close]', this.drawer).forEach(function (b) { b.addEventListener('click', function () { self.close(); }); });
      document.addEventListener('keydown', function (e) {
        if (!self.isOpen()) return;
        if (e.key === 'Escape') { e.preventDefault(); self.close(); }
        if (e.key === 'Tab') self.trap(e);
      });
      document.addEventListener('click', function (e) {
        var opener = e.target.closest && e.target.closest('[data-cart-open]');
        if (opener) { e.preventDefault(); self.refresh().then(function () { self.open(); }).catch(function () { window.location.href = routes.cartPage; }); }
      });
      $('[data-cart-lines]', this.drawer).addEventListener('click', function (e) {
        var btn = e.target.closest('[data-qty-change],[data-line-remove]');
        if (!btn) return;
        var key = btn.getAttribute('data-key');
        var line = (self.state && self.state.items || []).filter(function (i) { return i.key === key; })[0];
        if (!line) return;
        var q = btn.hasAttribute('data-line-remove') ? 0 : Math.max(0, line.quantity + Number(btn.getAttribute('data-qty-change')));
        self.change(key, q, btn.closest('.cart-line'));
      });
    },
    isOpen: function () { return this.drawer && this.drawer.classList.contains('is-open'); },
    open: function () {
      if (!this.drawer) { window.location.href = routes.cartPage; return; }
      var d = this.drawer;
      this.lastFocus = document.activeElement;
      d.hidden = false;
      requestAnimationFrame(function () { d.classList.add('is-open'); });
      document.body.classList.add('drawer-open');
      var panel = this.panel;
      setTimeout(function () { panel && panel.focus(); }, 30);
    },
    close: function () {
      var d = this.drawer;
      if (!d) return;
      d.classList.remove('is-open');
      document.body.classList.remove('drawer-open');
      setTimeout(function () { if (!d.classList.contains('is-open')) d.hidden = true; }, 300);
      if (this.lastFocus && this.lastFocus.focus) this.lastFocus.focus();
    },
    trap: function (e) {
      var f = $$('a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])', this.panel).filter(function (n) { return n.offsetParent !== null; });
      if (f.length === 0) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && (document.activeElement === first || document.activeElement === this.panel)) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    },
    refresh: function () {
      var self = this;
      return cartApi.get().then(function (cart) { self.render(cart); return cart; });
    },
    change: function (key, quantity, lineEl) {
      var self = this;
      if (lineEl) lineEl.classList.add('is-updating');
      var err = $('[data-cart-error]', this.drawer);
      if (err) err.hidden = true;
      return cartApi.change(key, quantity)
        .then(function (cart) { self.render(cart); })
        .catch(function (e) {
          if (lineEl) lineEl.classList.remove('is-updating');
          if (err) { err.textContent = (e && e.status && e.message) ? e.message : t('changeError', 'Couldn\'t update your cart.'); err.hidden = false; }
        });
    },
    render: function (cart) {
      this.state = cart;
      $$('[data-cart-count]').forEach(function (c) {
        c.textContent = cart.item_count;
        c.classList.toggle('is-empty', !cart.item_count);
      });
      if (!this.drawer) return;
      var list = $('[data-cart-lines]', this.drawer);
      var empty = $('[data-cart-empty]', this.drawer);
      var foot = $('[data-cart-foot]', this.drawer);
      list.textContent = '';
      var items = cart.items || [];
      empty.hidden = items.length > 0;
      foot.hidden = items.length === 0;
      items.forEach(function (item) {
        var li = el('li', 'cart-line');
        if (item.image) {
          var img = el('img', 'cart-line__img');
          img.src = sizedImage(item.image, 160);
          img.alt = item.product_title || '';
          img.width = 72; img.height = 72; img.loading = 'lazy';
          li.appendChild(img);
        } else { li.appendChild(el('span', 'cart-line__img')); }
        var info = el('div', 'cart-line__info');
        var title = el('a', 'cart-line__title', item.product_title);
        title.href = item.url || '#';
        info.appendChild(title);
        if (item.variant_title && !item.product_has_only_default_variant) {
          info.appendChild(el('p', 'cart-line__variant', t('size', 'Size') + ': ' + item.variant_title));
        }
        var qty = el('div', 'qty');
        var minus = el('button', 'qty__btn', '−');
        minus.type = 'button'; minus.setAttribute('data-qty-change', '-1'); minus.setAttribute('data-key', item.key);
        minus.setAttribute('aria-label', t('decrease', 'Decrease quantity') + ', ' + item.product_title + ' ' + (item.variant_title || ''));
        var val = el('span', 'qty__val', String(item.quantity));
        val.setAttribute('aria-live', 'polite');
        var plus = el('button', 'qty__btn', '+');
        plus.type = 'button'; plus.setAttribute('data-qty-change', '1'); plus.setAttribute('data-key', item.key);
        plus.setAttribute('aria-label', t('increase', 'Increase quantity') + ', ' + item.product_title + ' ' + (item.variant_title || ''));
        qty.appendChild(minus); qty.appendChild(val); qty.appendChild(plus);
        info.appendChild(qty);
        var rm = el('button', 'cart-line__remove', t('remove', 'Remove'));
        rm.type = 'button'; rm.setAttribute('data-line-remove', ''); rm.setAttribute('data-key', item.key);
        info.appendChild(rm);
        li.appendChild(info);
        var price = el('div', 'cart-line__price');
        if (item.original_line_price > item.final_line_price) price.appendChild(el('s', '', formatMoney(item.original_line_price)));
        price.appendChild(el('span', '', formatMoney(item.final_line_price)));
        (item.line_level_discount_allocations || []).forEach(function (a) {
          var title = (a.discount_application && a.discount_application.title) || '';
          price.appendChild(el('span', 'cart-line__discount', (title ? title + ' ' : '') + '−' + formatMoney(a.amount)));
        });
        li.appendChild(price);
        list.appendChild(li);
      });
      var savingsRow = $('[data-cart-savings-row]', this.drawer);
      var savings = $('[data-cart-savings]', this.drawer);
      if (savingsRow && savings) {
        savingsRow.hidden = !(cart.total_discount > 0);
        savings.textContent = '−' + formatMoney(cart.total_discount || 0);
      }
      var sub = $('[data-cart-subtotal]', this.drawer);
      if (sub) sub.textContent = formatMoney(cart.total_price);
      this.checkOffer(cart);
    },
    // Compare Shopify's applied discount with the advertised bundle offer.
    checkOffer: function (cart) {
      var note = $('[data-cart-mismatch]', this.drawer);
      var admin = $('[data-cart-admin-warning]', this.drawer);
      var result = { mismatch: false };
      if (bundleConfig) {
        var lines = (cart.items || []).filter(function (i) { return Number(i.product_id) === Number(bundleConfig.productId); });
        var qty = 0, original = 0, applied = 0;
        lines.forEach(function (i) { qty += i.quantity; original += i.original_line_price; applied += (i.original_line_price - i.final_line_price); });
        var pctNow = qty >= 3 ? bundleConfig.pct3 : (qty >= 2 ? bundleConfig.pct2 : 0);
        var expected = Math.round(original * pctNow / 100);
        var tolerance = Math.max(1, lines.length);
        result = { mismatch: Math.abs(expected - applied) > tolerance, expected: expected, applied: applied, qty: qty, percent: pctNow };
        if (result.mismatch) {
          console.warn('[Snow Dawg] Bundle discount mismatch: expected ' + formatMoney(expected) + ' (' + pctNow + '% on ' + qty + ' suits), Shopify applied ' + formatMoney(applied) + '. Check the automatic discounts in Shopify admin.');
        }
      }
      if (note) { note.hidden = !result.mismatch; note.textContent = t('mismatchCustomer', 'Bundle pricing is finalized at checkout.'); }
      if (admin) admin.hidden = !result.mismatch;
      this.lastCheck = result;
      return result;
    }
  };
  SDC.Cart = Cart;

  /* ---------- Black Friday countdown (fixed end date only) ---------- */
  function initCountdown(strip) {
    if (strip.__sdc) return;
    strip.__sdc = true;
    var raw = (strip.dataset.bfEnd || '').trim();
    var m = raw.match(/^(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{2}):(\d{2}))?$/);
    var out = $('[data-bf-countdown]', strip);
    if (!m) { if (out) out.hidden = true; return; }
    var off = (strip.dataset.bfOffset || '+0000').match(/^([+-])(\d{2})(\d{2})$/);
    var offsetMin = off ? (off[1] === '-' ? -1 : 1) * (Number(off[2]) * 60 + Number(off[3])) : 0;
    var end = Date.UTC(+m[1], +m[2] - 1, +m[3], +(m[4] || 23), +(m[5] || 59)) - offsetMin * 60000;
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function tick() {
      var diff = end - Date.now();
      if (diff <= 0) { strip.hidden = true; clearInterval(timer); return; }
      if (!out) return;
      var s = Math.floor(diff / 1000);
      var d = Math.floor(s / 86400); s -= d * 86400;
      var h = Math.floor(s / 3600); s -= h * 3600;
      var mi = Math.floor(s / 60); s -= mi * 60;
      out.textContent = 'Ends in ' + (d > 0 ? d + 'd ' : '') + pad(h) + 'h ' + pad(mi) + 'm ' + pad(s) + 's';
    }
    var timer = setInterval(tick, 1000);
    tick();
  }

  /* ---------- Size guide unit toggle ---------- */
  function initUnits(root) {
    if (root.__sdc) return;
    root.__sdc = true;
    var btns = $$('[data-unit]', root);
    btns.forEach(function (b) {
      b.addEventListener('click', function () {
        var unit = b.dataset.unit;
        btns.forEach(function (x) { var on = x === b; x.classList.toggle('is-active', on); x.setAttribute('aria-pressed', on ? 'true' : 'false'); });
        $$('[data-in]', root).forEach(function (n) { n.hidden = unit !== 'in'; });
        $$('[data-cm]', root).forEach(function (n) { n.hidden = unit !== 'cm'; });
      });
    });
  }

  /* ---------- Carousels (lifestyle, reviews) ---------- */
  function initCarousel(root) {
    if (root.__sdc) return;
    root.__sdc = true;
    var track = $('[data-carousel-track]', root);
    if (!track) return;
    function step() { var c = track.querySelector('li'); return c ? c.getBoundingClientRect().width + 14 : track.clientWidth * 0.8; }
    var p = $('[data-carousel-prev]', root), n = $('[data-carousel-next]', root);
    if (p) p.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (n) n.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
  }

  /* ---------- Boot ---------- */
  function init(scope) {
    scope = scope || document;
    $$('[data-announcement]', scope).forEach(initAnnouncement);
    $$('[data-gallery]', scope).forEach(initGallery);
    $$('[data-bundle]', scope).forEach(initBundle);
    $$('[data-buy-buttons]', scope).forEach(initBuyButtons);
    $$('[data-bf-strip]', scope).forEach(initCountdown);
    $$('[data-size-guide]', scope).forEach(initUnits);
    $$('[data-carousel]', scope).forEach(initCarousel);
    initNav();
    Cart.init();
  }
  SDC.init = init;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
